<div
        class="overlay"
        [class.visible]="(isLoading$ | async)"
>
    <mat-progress-spinner
            class="spinner"
            [color]="color"
            [mode]="mode"
            [value]="value">
    </mat-progress-spinner>
</div>